import React, { useState, useEffect } from 'react';
import {
  Dialog,
  Button,
  Grid,
  Typography,
  CircularProgress,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { poppins500, poppins400 } from 'theme/common.style';
import { useHistory, useLocation } from 'react-router-dom';
import { getApiCall } from 'api/apiService';
import { GET_DEPOSIT } from 'constant/app.config';
import DepositPaymentDetailsNew from 'component/BuyerRegistration/components/DepositPaymentDetailsNew';

const WarningIconRED = () => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4901 11.4607L11.5789 1.45599C11.0462 0.555115 10.0621 0 8.99672 0C7.9314 0 6.94728 0.555115 6.41462 1.45599L0.399495 11.632C-0.133165 12.5329 -0.133165 13.6431 0.399495 14.544C0.932154 15.4449 1.91628 16 2.9816 16H15.0119C15.0152 16 15.0184 16 15.0184 16C16.6651 16 18 14.6962 18 13.088C18 12.4853 17.8116 11.9239 17.4901 11.4607ZM10.2732 12.4345C10.2732 13.1229 9.73078 13.6495 9 13.6495C8.26922 13.6495 7.72681 13.1229 7.72681 12.4345V12.406C7.72681 11.7208 8.26922 11.1911 9 11.1911C9.73078 11.1911 10.2732 11.7177 10.2732 12.406V12.4345ZM10.3024 4.24425L9.67232 9.61776C9.6301 10.0048 9.36702 10.2458 9 10.2458C8.63298 10.2458 8.3699 10.0016 8.32768 9.61776L7.69758 4.24108C7.65536 3.82554 7.88599 3.5115 8.28221 3.5115H9.71454C10.1108 3.51467 10.3446 3.82871 10.3024 4.24425Z"
        fill="#FF3B30"
      />
    </svg>
  );
};

const Pendingwarningred = () => {
  return (
    <svg
      width="38"
      height="37"
      viewBox="0 0 38 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.5"
        width="37.5797"
        height="36"
        rx="18"
        fill="#F93939"
        fill-opacity="0.1"
      />
      <path
        d="M27.0817 21.9607L21.3085 11.956C20.7883 11.0551 19.8271 10.5 18.7866 10.5C17.7462 10.5 16.7851 11.0551 16.2648 11.956L10.3902 22.132C9.86994 23.0329 9.86994 24.1431 10.3902 25.044C10.9104 25.9449 11.8715 26.5 12.912 26.5H24.6614C24.6646 26.5 24.6677 26.5 24.6677 26.5C26.276 26.5 27.5797 25.1962 27.5797 23.588C27.5797 22.9853 27.3957 22.4239 27.0817 21.9607ZM20.0333 22.9345C20.0333 23.6229 19.5036 24.1495 18.7898 24.1495C18.0761 24.1495 17.5464 23.6229 17.5464 22.9345V22.906C17.5464 22.2208 18.0761 21.6911 18.7898 21.6911C19.5036 21.6911 20.0333 22.2177 20.0333 22.906V22.9345ZM20.0619 14.7443L19.4465 20.1178C19.4052 20.5048 19.1483 20.7458 18.7898 20.7458C18.4314 20.7458 18.1745 20.5016 18.1332 20.1178L17.5178 14.7411C17.4766 14.3255 17.7019 14.0115 18.0888 14.0115H19.4877C19.8747 14.0147 20.1031 14.3287 20.0619 14.7443Z"
        fill="#F93939"
      />
    </svg>
  );
};

const DepositOverdue = ({
  open,
  onClose,
  streetName,
  propertyId,
  getBuyerIndividualValue,
  individualPage,
  setPaymentPop,
  flagSign,
  flagSignStatus,
  setShowActivateTrade,
}) => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const isXsScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const [depositeopen, setDepositeopen] = useState(false);
  const [getDeposit, setGetDeposit] = useState();
  const GetDeposit = () => {
    let accesstoken = 'Bearer ' + localStorage.getItem('accesstoken');
    getApiCall(`${GET_DEPOSIT.replace(/\/$/, '')}/${propertyId}`, {
      method: 'GET',
      headers: {
        Authorization: accesstoken,
        'Content-Type': 'application/json',
      },
    }).then((res) => {
      setGetDeposit(res?.data);
      setDepositeopen(true);
    });
  };
  const history = useHistory();

  const handleDepositPaymentClick = () => {
    if (!individualPage) {
      history.push({
        pathname: `market/${propertyId}`,
        state: { triggerGetDeposit: true },
      });
    } else {
      setShowActivateTrade(true);
      GetDeposit();
    }
  };

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            maxWidth: '721px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '30px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {'   '}
              {streetName}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarningred />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '18px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Deposit Payment - OVERDUE
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              sx={{ ...poppins400, fontSize: '16px', color: '#666666' }}
            >
              You have an OVERDUE deposit payment for{' '}
              <span>
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 550,
                    color: '#666666',
                  }}
                >
                  {streetName}
                </b>
              </span>
              . Please process this payment immediately as you are now in
              default of your deposit payment obligations. 
            </Typography>
          </Grid>
          <Grid
            item
            container
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              border: '1px solid',
              borderColor: '#FF3B30',
              bgcolor: 'rgba(249, 57, 57, 0.1)',
              padding: 2,
              mt: '30px',
              alignItems: 'center',
              mr: '-30px',
            }}
          >
            <Grid item xs={1} sx={{ display: 'flex', alignItems: 'center' }}>
              <WarningIconRED fontSize={isXsScreen ? 'small' : 'medium'} />
            </Grid>
            <Grid item xs={10}>
              <Typography
                sx={{ ...poppins400, color: '#666666', fontSize: '16px' }}
              >
                Should you fail to process your deposit payment today, your
                account will restricted and you remain at risk of being
                permanently barred.
                <br />
                <br />
                Please process your deposit payment immediately to avoid further
                action.
              </Typography>
            </Grid>
          </Grid>

          <Grid
            item
            container
            direction="row"
            sx={{ display: 'flex', alignItems: 'center' }}
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? '15px' : 5}
          >
            <Grid item>
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={onClose}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                  cursor: 'pointer',
                }}
                onClick={handleDepositPaymentClick}
              >
                Deposit Payment
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
      <DepositPaymentDetailsNew
        open={depositeopen}
        setDepositeopen={setDepositeopen}
        data={getDeposit}
        getBuyerIndividualValue={getBuyerIndividualValue}
        setPaymentPop={setPaymentPop}
      />
    </>
  );
};

export default DepositOverdue;
